import { useRef, useState } from "react";
import { OrderSupplier, SearchSupplierApiParams } from "../types";
import orderSupplierListApi from "../api/orderSupplierListApi";
import { Severity } from "../../../type";

const limit = 10;

/**
 * 仕入先・外部倉庫用受注商品一覧取得
 * @param showAlert エラー表示
 */
export default function useOrderSupplierList(
  showAlert: (msg: string, severity?: Severity) => void,
) {
  const [total, setTotal] = useState(0); // 在庫のレコードの総数
  const [orderList, setOrderList] = useState<OrderSupplier[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isMoreLoading, setIsMoreLoading] = useState(false);
  const [offset, setOffset] = useState(0);
  const isFastLoading = useRef(false); // 二重読み込み防止
  const [fireMoreLoadEvent, setFireMoreLoadEvent] = useState(false); // スクロール最下層に達した時、値を変更して発火させるイベント
  const [init, setInit] = useState(false);

  const get = async (searchParams: SearchSupplierApiParams) => {
    isFastLoading.current = true;
    setIsLoading(true);
    try {
      // offset, limitは必須なのでparamsに付け足す。
      const res = await orderSupplierListApi({
        ...searchParams,
        ...{
          offset: 0,
          limit,
        },
      });
      const oList = res.orders;
      setTotal(res.total);
      setOrderList(structuredClone(oList));
      setOffset(oList.length);
    } catch (err) {
      console.error(err);
      showAlert("受注商品一覧情報の取得に失敗しました。", "error");
    } finally {
      isFastLoading.current = false;
      setIsLoading(false);
    }
  };

  const getMore = async (searchParams: SearchSupplierApiParams) => {
    if (orderList.length >= total || !init) {
      isFastLoading.current = false;
      return;
    }
    console.log("orderList.lenght, total:", orderList.length, total);

    isFastLoading.current = true;
    setIsMoreLoading(true);
    try {
      const res = await orderSupplierListApi({
        limit,
        offset,
        ...searchParams,
      });
      setTotal(res.total);
      setOrderList((prev) => [...prev, ...res.orders]);
      setOffset((prev) => prev + res.orders.length);
    } catch (err) {
      console.error(err);
      showAlert("受注商品一覧情報の取得に失敗しました。", "error");
    } finally {
      isFastLoading.current = false;
      setIsMoreLoading(false);
    }
  };

  // const getChangedList = () => {
  //   const list: OrderSupplier[] = [];
  //   orderList.forEach(o => {
  //     if (
  //       o.changedShippingCompanyName !== "" // 入力必須のため出荷情報設定されていると判定
  //     ) {
  //       list.push(o);
  //     }
  //   });
  //   return list;
  // }

  return [
    { total, orderList, isLoading, isMoreLoading, isFastLoading, fireMoreLoadEvent },
    { setOrderList, get, getMore, setFireMoreLoadEvent, setInit, setTotal },
  ] as const;
}
